import { create } from 'zustand';
import { devtools } from "zustand/middleware";
import type { IFilters } from '@app/dashboard/types/zustand/filters';
import type { IFiltersStore } from '@app/dashboard/types/zustand/filters';
import { getDefaultDates } from '@app/dashboard/utils/dateRangePicker';

export const useFiltersStore = create<IFiltersStore>()(
  devtools(
    (set) => ({
      filters: {
        ...getDefaultDates(),
        selectedRangeName: undefined,
        channel: undefined,
        currency: undefined,
        is_live: false
      },
      setFilters: (newFilters: Partial<IFilters>) => set(
        (prevState) => ({ filters: { ...prevState.filters, ...newFilters } }),
        undefined,
        'FiltersStore/setFilters'
      )
    }),
    { name: 'FiltersStore' }
  )
);